import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import { clientTypeConstants } from "../constants/clientType.constants";
import { HubConnectionBuilder } from "@aspnet/signalr";
import Axios from "axios";
import { getKey } from "../../helpers/UrlHelper";
import { ConnectionStatus } from "../../digitalArena/components/fallbacks/ConnectionStatus";
import { Loader } from "../../digitalArena/utils/ClientConnectionFallback";
import { Button, List, ListItem, ListItemText, ListItemIcon, Divider, IconButton, ListItemSecondaryAction, Tooltip } from "@material-ui/core";
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import BrokenImageIcon from '@material-ui/icons/BrokenImage';
import DeleteIcon from '@material-ui/icons/Delete';
import CreateChannelDialog from "./components/CreateChannelDialog";
import SystemLabel from '../../system/SystemLabel/SystemLabel';
// import { cmsActions } from "../../store/actions/cms/cms.action";
const wrapperStyle = {
    width: "100%",
    height: "100vh",
    display: "inline-flex",
    backgroundColor: "#1d1d1d",
    justifyContent: "center",
    alignItems: "center"
};
const listCol = {
    width: "100%",
    maxWidth: "1000px",
    minWidth: "300px",
    height: "100%",
    backgroundColor: "#222",
    zIndex: 1,
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0), 0 2px 4px rgba(0, 0, 0, 0), 0 4px 8px rgba(0, 0, 0, 0), 0 4px 4px rgba(0, 0, 0, 0), 0 4px 4px rgba(0, 0, 0, 0), 0 20px 20px rgba(0, 0, 0, 0.3) !important",
};
const listStyle = {
    maxHeigth: "100%",
    overflowY: "auto",
    maxHeight: "calc(100vh - 73px)",
    minHeight: "calc(100vh - 73px)",
};
const ChannelList = ({ match, user, ...props }) => {
    const [clientKey, setClientKey] = useState(null);
    const [tickCode, setTickCode] = useState(null);
    const [hubConnection, setHubConnection] = useState(null);
    const [connecting, setConnecting] = useState(false);
    const [connected, setConnected] = useState(false);
    const [eventId, setEventId] = useState(null);
    const [eventName, setEventName] = useState(null);
    const [eventCode, setEventCode] = useState(null);
    const [eventList, setEventList] = useState([]);
    const [channelList, setChannelList] = useState([]);
    const [connectionList, setConnectionList] = useState([]);
    const [languageCode, setLanguageCode] = useState("swe");
    const [init, setInit] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const connectionListTimerRef = useRef();
    const channelListTimerRef = useRef();
    const channels = useMemo(() => {
        var chList = [];
        channelList.map((cl) => {
            if (cl.channel) {
                var ch = chList.find(c => c.channel === cl.channel);
                if (!ch) {
                    chList.push({ staticChannelListId: cl.staticChannelListId, eventId: cl.eventId, channel: cl.channel, count: 0 });
                }
                else {
                    ch.count += 1;
                }
            }
        });
        connectionList.map((cl) => {
            var ch = chList.find(c => c.channel === cl.channel);
            if (!ch) {
                chList.push({ eventId: cl.eventId, channel: cl.channel, count: 1 });
            }
            else {
                ch.count += 1;
            }

        })
        return chList;
    }, [channelList, connectionList])
    useEffect(() => {
        const ec = match.params.id;
        setEventCode(ec);
        getEventId(ec);
        const params = new URLSearchParams(props.location.search);
        const lang = params.get(getKey("lang", params));
        const ck = params.get(getKey("clientKey", params));
        const bno = params.get(getKey("badgeNo", params));
        if (ck) setClientKey(ck);
        else if (bno) setClientKey(bno);
        if (lang) setLanguageCode(lang);
        // this.props.dispatch(templateActions.getDefaultTemplateByEvent(eventId));
        // props.dispatch(cmsActions.setEnviroment(sourceTypes.INTERACTION, false));
        
    }, [])

    useEffect(() => {
        if (hubConnection) {
            hubConnection.on("onHandshake", onHandshake);
            hubConnection.on("onGetActiveChatConnections", onGetActiveChatConnections);
            hubConnection.on("onGetStaticChannelList", onGetStaticChannelList);
            hubConnection.on("onDeleteStaticChannel", onDeleteChannel);
            hubConnection.onclose(onClose);
        }
        return () => {
            if (hubConnection) {
                hubConnection.off("onHandshake", onHandshake);
                hubConnection.off("onGetActiveChatConnections", onGetActiveChatConnections);
                hubConnection.off("onGetStaticChannelList", onGetStaticChannelList);
                hubConnection.off("onDeleteStaticChannel", onDeleteChannel);
            }
        }
    })
    useEffect(() => {
        if (eventId > 0 && !connected && !connecting) {
            connectToHub();
        }
    }, [eventId])
    useEffect(() => {
        if (connected && !connectionListTimerRef.current)
            connectionListTimerRef.current = setInterval(() => { hubConnection.invoke("getActiveChatConnections", eventId); }, 5000);
        else if (!connected && connectionListTimerRef.current) {
            clearInterval(connectionListTimerRef.current)
            connectionListTimerRef.current = null;
        }
        if (connected && !channelListTimerRef.current)
            channelListTimerRef.current = setInterval(() => { hubConnection.invoke("getStaticChannelList", eventId); }, 30000);
        else if (!connected && channelListTimerRef.current) {
            clearInterval(channelListTimerRef.current)
            channelListTimerRef.current = null;
        }
    }, [connected])

    const getEventId = (eventCode) => {
        Axios.get(`./api/event/getId/${eventCode}`)
            .then((res) => {
                setEventId(res.data.id);
                setEventName(res.data.name);
                if (languageCode == "swe")
                    document.title = "Kanaler - " + res.data.name;
                else
                    document.title = "Channels - " + res.data.name;
                Axios.get(`./api/event/getall/${res.data.id}`).then((res) => {
                    setEventList(res.data);
                })
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const connectToHub = () => {
        var hc = hubConnection;
        try {
            if (!hc) {
                hc = new HubConnectionBuilder().withUrl("./ihub").build();
            }
        } catch (error) { }
        setConnecting(true)
        setHubConnection(hc);
        hc.start()
            .then(() => {
                hc.invoke("handshake", {
                    eventId,
                    clientType: clientTypeConstants.INTERACTION_CHANNEL_LIST,
                    clientKey,
                    userGuid: user ? user.userGuid : null,
                })
                    .catch((err) => {
                        console.error(err);
                    });
                hc.invoke("getActiveChatConnections", eventId);
                hc.invoke("getStaticChannelList", eventId);
            })
            .catch((error) => { });

    };
    const onClose = () => {
        setConnected(false);
    }
    const onHandshake = (response) => {
        if (response.success) {
            setConnected(true);
            setConnecting(false);
            setInit(true);
            setTickCode(response.tickCode)
        }
    };
    const onGetActiveChatConnections = (connectionList) => {
        let cL = connectionList.filter((cl) => cl.type === clientTypeConstants.INTERACTION_MEETING);
        setConnectionList(cL);

    };
    const onGetStaticChannelList = (chList) => {
        setChannelList(chList);
    }
    const openRoom = (evCode, chName) => {
        window.open(
            `${window.location.origin}${!window.location.toString().includes("localhost") ? "/interaction" : ""}/digitalarena/${evCode}?clientkey=${clientKey}&lang=${languageCode}${chName ? `&channel=${encodeURIComponent(chName)}` : ''}`,
            "_blank"
        )
    }
    const createStaticChannel = (evId, chName) => {
        if (hubConnection) {
            hubConnection.invoke("createStaticChannel", evId, chName);
            setDialogOpen(false);
        }
    }
    const deleteChannel = (ch) => {
        if (hubConnection) {
            hubConnection.invoke("deleteStaticChannel", eventId, ch.staticChannelListId)
        }
    }
    const onDeleteChannel = (staticChannelListId) => {
        if (channelList.find(x => x.staticChannelListId === staticChannelListId)) {
            setChannelList([...channelList.filter(x => x.staticChannelListId !== staticChannelListId)])
        }
    }
    if (!init) return <Loader />
    return <React.Fragment>
        <ConnectionStatus connected={connected} connecting={connecting} hubConnection={hubConnection} />
        <div style={wrapperStyle} className="primary-text">
            <div style={listCol}>
                <h2>{eventName}</h2>
                {clientKey.startsWith("sneakyspy") || clientKey.startsWith(tickCode) ?
                    <div>
                        <Button variant="outlined" className="primary-text" onClick={() => setDialogOpen(true)} ><SystemLabel name={"CreateChannelButton"} /></Button>
                    </div>
                    : null}
                <List style={listStyle} dense component="nav" className="dark-list" aria-label="main mailbox folders">
                    {eventList.map((ev, i) => {
                        const mainRoomChannel = channels.find((ch) => ch.eventId == ev.eventId && !ch.channel);
                        return (
                            <React.Fragment key={i}>
                                <ListItem>
                                    <ListItemIcon className="primary-text" >
                                    <Tooltip title={<SystemLabel name={"RoomIconTooltip"} />}>
                                        <BrokenImageIcon />
                                    </Tooltip>
                                    </ListItemIcon>
                                    <ListItemText className="primary-text" style={{ width: "75%" }} primary={ev.name} />
                                    <ListItemText className="primary-text" primary={`${mainRoomChannel ? mainRoomChannel.count : 0}`} />
                                    <ListItemSecondaryAction>
                                        <Tooltip title={<SystemLabel name={"OpenChannel"} />}>
                                            <IconButton style={{ color: "rgba(238, 238, 238, 0.37)" }} onClick={() => openRoom(ev.code, null)}>
                                                <MeetingRoomIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <Divider style={{ backgroundColor: "rgba(238, 238, 238, 0.27)" }} component="li" />
                                {channels.filter(ch => ch.eventId === ev.eventId && ch.channel).map((ch, i) => {
                                    return <React.Fragment key={i}>
                                        <ListItem>
                                            <ListItemIcon className="primary-text" style={{ marginLeft: "5%" }} >
                                            <Tooltip title={<SystemLabel name={"ChannelIconTooltip"} />}>
                                                <BrokenImageIcon />
                                            </Tooltip>
                                            </ListItemIcon>
                                            <ListItemText className="primary-text" style={{ width: "70%" }} primary={ch.channel} />
                                            <ListItemText className="primary-text" primary={`${ch.count}`} />
                                            <ListItemSecondaryAction>
                                                {ch.staticChannelListId ?
                                                    <Tooltip title={<SystemLabel name={"DeleteChannel"} />}>
                                                        <IconButton style={{ background: "orangered", borderRadius: '5px', color: "white", padding: "8px" }} onClick={() => deleteChannel(ch)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    : null}
                                                <Tooltip title={<SystemLabel name={"OpenChannel"} />}>
                                                    <IconButton style={{ color: "rgba(238, 238, 238, 0.37)" }} onClick={() => openRoom(ev.code, ch.channel)}>
                                                        <MeetingRoomIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </ListItemSecondaryAction>

                                        </ListItem>
                                        <Divider style={{ backgroundColor: "rgba(238, 238, 238, 0.27)" }} component="li" />
                                    </React.Fragment>
                                })}
                            </React.Fragment>)
                    })}
                </List>
            </div>
        </div>
        {dialogOpen ?
            <CreateChannelDialog handleClose={() => setDialogOpen(false)} save={createStaticChannel} eventList={eventList} parentEventId={eventId} />
            : null}
    </React.Fragment>
}
function mapStateToProps(state) {
    return {
        user: state.authentication.user,
    };
}
export default connect(mapStateToProps)(ChannelList);


{/* <div style={listCol} className="stage-list">
     <div style={questionHeaderStyle}>
        <Typography className="primary-text" style={{ fontSize: "1.4rem" }}>
            {" "}
            <SystemLabel name="Questions" languageCode={lang} /> - {eventName}
        </Typography>
        <Typography className="primary-text" style={{ fontSize: "0.8rem" }}>
            {" "}
            <SystemLabel name="ConnectionCount" languageCode={lang} /> {connectionList.length}
        </Typography>
    </div> 
    <List style={listStyle} component="nav" className="dark-list" aria-label="main mailbox folders">
        {questions && questions.length > 0
            ? questions
                .filter((q) => q.type == "Text" && (!q.tag || (q.tag && !q.tag.includes("hideinstage"))))
                .map((q, i) => {
                    let qLang = q.questionLanguage.find((ql) => ql.languageCode == lang);
                    let qActive = activeQuestions.some((aq) => aq === q.questionId);
                    return (
                        <React.Fragment key={i}>
                            <ListItem
                                onClick={() => this.toggleQuestion(q)}
                                style={{
                                    listStyle: "none",
                                    display: "flex",
                                }}
                                ref={i}
                                key={i}
                            >
                                { }
                                <ListItemAvatar >{this.renderTypeIcon(q.type, qActive)}</ListItemAvatar>
                                <ListItemText className="primary-text" style={{ maxWidth: "65%" }} secondary={q.tag} primary={qLang ? qLang.label : "NoLabel"} />
                                <ListItemSecondaryAction>
                                    <IconButton style={{ color: "rgba(238, 238, 238, 0.37)" }} onClick={() => this.toggleQuestion(q)}>
                                        <ChevronRightIcon />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                            <Divider variant="inset" component="li" />
                        </React.Fragment>
                    );
                })
            : null}
    </List>
</div> */}